import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Button,
  Column,
  Editing,
  FilterRow,
  Form,
  Label,
  LoadPanel,
  MasterDetail,
  Paging,
  Popup,
  RequiredRule,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { EmptyItem, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getDateString } from "../common/date";
import { notifyMsg } from "../common/notify";
import { PRJ_TP, PRJ_TPList } from "./data";
import TwoDateCheckBoxComponent from "./TwoDateCheckBoxComponent";
import TwoNumberBoxComponent from "./TwoNumberBoxComponent";

export default function ProjectPerformanceHistoryClinicalTrials() {
  const [dataSource, setDataSource] = useState(null);

  const [PRJ_TPDataSource, setPRJ_TPDataSource] = useState(null);
  const [APPLY_ENTP_NAMEDataSource, setAPPLY_ENTP_NAMEDataSource] =
    useState(null);
  const [CLINIC_STEP_NAMEDataSource, setCLINIC_STEP_NAMEDataSource] =
    useState(null);
  const [TRGT_DISS_NMDataSource, setTRGT_DISS_NMDataSource] = useState(null);

  const [classifPrjNameDataSource, setClassifPrjNameDataSource] =
    useState(null);

  const [formDataSource, setFormDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const projectPerformanceHistoryClinicalTrialsGridRef = useRef(null);
  const mdcinClincTestInfoService01GridRef = useRef(null);
  const siteCtRef = useRef(null);
  const sCtRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const psRef = useRef(null);

  useEffect(async () => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          values = {
            ...values,
            id: mdcinClincTestInfoService01GridRef.current.instance.getSelectedRowsData()[0]
              .id,
            siteCt: siteCtRef.current.instance.option("value"),
            sCt: sCtRef.current.instance.option("value"),
            startDate: startDateRef.current.instance.option("value"),
            endDate: endDateRef.current.instance.option("value"),
            ps: psRef.current.instance.option("value") == true ? "1" : "0",
          };

          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          values = {
            ...values,
            id: mdcinClincTestInfoService01GridRef.current.instance.getSelectedRowsData()[0]
              .id,
            siteCt: siteCtRef.current.instance.option("value"),
            sCt: sCtRef.current.instance.option("value"),
            startDate: startDateRef.current.instance.option("value"),
            endDate: endDateRef.current.instance.option("value"),
            ps: psRef.current.instance.option("value") == true ? "1" : "0",
          };

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );

    setPRJ_TPDataSource(
      new DataSource({
        store: PRJ_TPList,
        type: "array",
        key: "id",
      })
    );

    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/APPLY_ENTP_NAME`
    );

    setAPPLY_ENTP_NAMEDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: ["PRJ_TP", "APPLY_ENTP_NAME"],
        },
      })
    );

    const result2 = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/CLINIC_STEP_NAME`
    );

    setCLINIC_STEP_NAMEDataSource(
      new DataSource({
        store: {
          data: result2.data,
          type: "array",
          key: "CLINIC_STEP_NAME",
        },
      })
    );

    setClassifPrjNameDataSource(
      new CustomStore({
        key: "id",
        load: async () => {
          let gridInstance =
            projectPerformanceHistoryClinicalTrialsGridRef.current.instance;
          let editRowKey = gridInstance.option("editing.editRowKey");
          let index = gridInstance.getRowIndexByKey(editRowKey);
          index = index === -1 ? 0 : index;

          const PRJ_TP = gridInstance.cellValue(index, "PRJ_TP");
          const APPLY_ENTP_NAME = gridInstance.cellValue(
            index,
            "APPLY_ENTP_NAME"
          );
          const CLINIC_STEP_NAME = gridInstance.cellValue(
            index,
            "CLINIC_STEP_NAME"
          );

          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/classifPrjName?PRJ_TP=${PRJ_TP}&APPLY_ENTP_NAME=${APPLY_ENTP_NAME}&CLINIC_STEP_NAME=${CLINIC_STEP_NAME}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/classifPrjName`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/classifPrjName/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/classifPrjName/${key}`
          );
        },
      })
    );

    const result3 = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/MEDRAIndn`
    );

    setTRGT_DISS_NMDataSource(
      new DataSource({
        store: {
          data: result3.data,
          type: "array",
          key: "lltCode",
        },
      })
    );
  }, []);

  const setPRJ_TPCellValue = (newData, value) => {
    newData.PRJ_TP = value;

    // mdcinClincTestInfoService01GridRef.current.instance.filter([
    //   "PRJ_TP",
    //   "=",
    //   value,
    // ]);

    // const filterExpr =
    //   mdcinClincTestInfoService01GridRef.current.instance.getCombinedFilter(
    //     true
    //   );

    // console.debug("filterExpr", filterExpr);
  };

  const setAPPLY_ENTP_NAMECellValue = (newData, value) => {
    newData.APPLY_ENTP_NAME = value;
  };

  const setCLINIC_EXAM_TITLECellValue = (newData, value) => {
    newData.CLINIC_EXAM_TITLE =
      newData.GOODS_NAME =
      newData.GNRL_CD_NM =
      newData.TRGT_DISS_NM =
        value;
  };

  const setGOODS_NAMECellValue = (newData, value) => {
    newData.CLINIC_EXAM_TITLE =
      newData.GOODS_NAME =
      newData.GNRL_CD_NM =
      newData.TRGT_DISS_NM =
        value;
  };

  const setCLINIC_STEP_NAMECellValue = (newData, value) => {
    newData.CLINIC_STEP_NAME = value;
  };

  //   const onCustomAPPLY_ENTP_NAMEItemCreating = (args) => {};

  const onInitNewRow = (e) => {
    let gridInstance =
      projectPerformanceHistoryClinicalTrialsGridRef.current.instance;
    let editRowKey = gridInstance.option("editing.editRowKey");
    let index = gridInstance.getRowIndexByKey(editRowKey);
    index = index === -1 ? 0 : index;

    const PRJ_TP = gridInstance.cellValue(index, "PRJ_TP");
    const APPLY_ENTP_NAME = gridInstance.cellValue(index, "APPLY_ENTP_NAME");
    const CLINIC_STEP_NAME = gridInstance.cellValue(index, "CLINIC_STEP_NAME");

    e.data.PRJ_TP = PRJ_TP;
    e.data.APPLY_ENTP_NAME = APPLY_ENTP_NAME;
    e.data.CLINIC_STEP_NAME = CLINIC_STEP_NAME;
  };

  const onInitNewRow2 = (e) => {
    setFormDataSource((prevState) => ({
      ...prevState,
      ps: false,
    }));
  };

  const displayExpr = (item) => {
    if (item) {
      return `${item.lltNameKOR} (${item.lltName})`;
    } else {
      return null;
    }
  };

  const onEditingStart = (e) => {
    if (e.data.TRGT_DISS_NM && typeof e.data.TRGT_DISS_NM == "string") {
      e.data.TRGT_DISS_NM = e.data.TRGT_DISS_NM.split(",");
    }
  };

  const editNDeleteDisabled = (e) => {
    const { IS_CUST } = e.row.data;

    if (IS_CUST == 0) {
      return true;
    }

    return false;
  };

  const calculateDisplayValue = (data) => {
    return `${
      data.TRGT_DISS_NM_MEDRA
        ? data.TRGT_DISS_NM_MEDRA
        : data.TRGT_DISS_NM
        ? data.TRGT_DISS_NM
        : ``
    }`;
  };

  const onSaving = React.useCallback(async (e) => {
    const project =
      mdcinClincTestInfoService01GridRef.current.instance.getSelectedRowsData();

    if (project.length == 0) {
      notifyMsg("프로젝트를 선택해주세요", "error");

      e.cancel = true;
    } else {
      if (e.changes.length == 0) {
        const key =
          projectPerformanceHistoryClinicalTrialsGridRef.current.instance.option(
            "editing.editRowKey"
          );

        const values = {
          id: mdcinClincTestInfoService01GridRef.current.instance.getSelectedRowsData()[0]
            .id,
          siteCt: siteCtRef.current.instance.option("value"),
          sCt: sCtRef.current.instance.option("value"),
          startDate: startDateRef.current.instance.option("value"),
          endDate: endDateRef.current.instance.option("value"),
          ps: psRef.current.instance.option("value") == true ? "1" : "0",
        };

        await axios.put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/ct/${userInfo.employeeNo}/${key}`,
          values
        );

        projectPerformanceHistoryClinicalTrialsGridRef.current.instance.refresh();
      }
    }
  }, []);

  const calculateDisplayPRJ_TPValue = (data) => {
    return PRJ_TP[data.PRJ_TP];
  };

  function render(props) {
    const { role, roleP, startDate, endDate, ps, details } = props.data;

    return (
      <div>
        <table>
          <tbody>
            <tr>
              <th>수행업무: </th>
              <td>{role}</td>
            </tr>
            <tr>
              <th>프로젝트 내 역할: </th>
              <td>{roleP}</td>
            </tr>
            <tr>
              <th>수행기간: </th>
              <td>
                {getDateString(new Date(startDate))} ~{" "}
                {endDate ? getDateString(new Date(endDate)) : `현재`}
              </td>
            </tr>
            <tr>
              <th>상세내용: </th>
              <td>{details}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  const onEditingStart2 = (e) => {
    if (e.data.siteCt) {
      setFormDataSource((prevState) => ({
        ...prevState,
        siteCt: e.data.siteCt,
      }));
    }

    if (e.data.sCt) {
      setFormDataSource((prevState) => ({
        ...prevState,
        sCt: e.data.sCt,
      }));
    }

    if (e.data.startDate) {
      setFormDataSource((prevState) => ({
        ...prevState,
        startDate: e.data.startDate,
      }));
    }

    if (e.data.endDate) {
      setFormDataSource((prevState) => ({
        ...prevState,
        endDate: e.data.endDate,
      }));
    }

    if (e.data.ps) {
      setFormDataSource((prevState) => ({
        ...prevState,
        ps: e.data.ps,
      }));
    }
  };

  const onContentReady = (e) => {
    let gridInstance =
      projectPerformanceHistoryClinicalTrialsGridRef.current.instance;
    let editRowKey = gridInstance.option("editing.editRowKey");
    let index = gridInstance.getRowIndexByKey(editRowKey);
    index = index === -1 ? 0 : index;

    const id = gridInstance.cellValue(index, "id");

    if (id) {
      e.component.selectRows(id, true);
    }
  };

  return (
    <DataGrid
      id="projectPerformanceHistoryClinicalTrialsGrid"
      ref={projectPerformanceHistoryClinicalTrialsGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onSaving={onSaving}
      onInitNewRow={onInitNewRow2}
      onEditingStart={onEditingStart2}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Project Performance History"}
          confirmDeleteMessage="Are you sure you want to delete this project performance history?"
        />
        <Popup
          title={"Project Performance History"}
          showTitle={true}
          height="auto"
        />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="projectPerformanceHistory"
          height={"100%"}
          // customizeItem={customizeItem}
        >
          <SimpleItem
            dataField={"PRJ_TP"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: PRJ_TPDataSource,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
            }}
          >
            <Label text={"프로젝트 구분"} />
            <RequiredRule message={"* 프로젝트 구분을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"APPLY_ENTP_NAME"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: APPLY_ENTP_NAMEDataSource,
              valueExpr: "APPLY_ENTP_NAME",
              displayExpr: "APPLY_ENTP_NAME",
              showClearButton: true,
              searchEnabled: true,
              searchMode: "contains",
              searchExpr: "APPLY_ENTP_NAME",
              searchTimeout: 200,
              minSearchLength: 0,
              showDataBeforeSearch: false,
              // acceptCustomValue: true,
              // onCustomItemCreating: onCustomAPPLY_ENTP_NAMEItemCreating,
            }}
          >
            <Label text={"회사명"} />
            <RequiredRule message={"* 회사명을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"CLINIC_STEP_NAME"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: CLINIC_STEP_NAMEDataSource,
              valueExpr: "CLINIC_STEP_NAME",
              displayExpr: "CLINIC_STEP_NAME",
              showClearButton: true,
              searchEnabled: true,
              searchMode: "contains",
              searchExpr: "CLINIC_STEP_NAME",
              searchTimeout: 200,
              minSearchLength: 0,
              showDataBeforeSearch: false,
            }}
          >
            <Label text={"Phase"} />
            <RequiredRule message={"* Phase를 입력해주세요."} />
          </SimpleItem>
          <EmptyItem />
          <SimpleItem dataField={"classifPrjName"} colSpan={4}>
            <Label text={"프로젝트"} />
            <DataGrid
              id="mdcinClincTestInfoService01Grid"
              ref={mdcinClincTestInfoService01GridRef}
              dataSource={classifPrjNameDataSource}
              keyExpr="SEQ"
              rowAlternationEnabled={true}
              showBorders={true}
              showColumnLines={true}
              allowColumnResizing={true}
              columnAutoWidth={true}
              wordWrapEnabled={true}
              allowColumnReordering={true}
              style={{
                maxHeight: "calc(100vh - 180px)",
                marginLeft: "10px",
                marginRight: "10px",
                // marginTop: "56px",}
              }}
              hoverStateEnabled={true}
              showColumnHeaders={true}
              height={500}
              // repaintChangesOnly={true}
              onInitNewRow={onInitNewRow}
              onEditingStart={onEditingStart}
              onContentReady={onContentReady}
            >
              <LoadPanel enabled={true} />

              <Scrolling
                mode={"virtual"}
                rowRenderingMode="virtual"
                showScrollbar={"always"}
              />
              <Paging defaultPageSize={2} />
              {/* <Scrolling rowRenderingMode={"virtual"} />
                    <Paging defaultPageSize={5} /> */}
              {/* <Pager
                      visible={true}
                      allowedPageSizes={[5, 10]}
                      displayMode={"full"}
                      showPageSizeSelector={true}
                      showInfo={true}
                      showNavigationButtons={true}
                    /> */}

              <Selection mode={"single"} />

              {/* <HeaderFilter visible={true} />
               */}
              <FilterRow visible={true} />

              <Editing
                mode={"form"}
                allowAdding={true}
                allowUpdating={true}
                allowDeleting={true}
              >
                <Texts
                  confirmDeleteTitle={"Delete the Project"}
                  confirmDeleteMessage="Are you sure you want to delete this project?"
                />
                <Form
                  labelMode={"outside"}
                  showColonAfterLabel={false}
                  labelLocation="top"
                  minColWidth={300}
                  colCount={2}
                  colCountByScreen={{ sm: 2, md: 4 }}
                  screenByWidth={(width) => {
                    return width < 720 ? "sm" : "md";
                  }}
                  validationGroup="educationalHistory"
                  height={"auto"}
                >
                  <SimpleItem
                    dataField={"PRJ_TP"}
                    editorType="dxSelectBox"
                    editorOptions={{
                      dataSource: PRJ_TPDataSource,
                      valueExpr: "id",
                      displayExpr: "name",
                      showClearButton: true,
                      // disabled: true,
                    }}
                  >
                    <Label text={"프로젝트 구분"} />
                    <RequiredRule message={"* 프로젝트 구분을 입력해주세요."} />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"APPLY_ENTP_NAME"}
                    editorType="dxSelectBox"
                    editorOptions={{
                      dataSource: APPLY_ENTP_NAMEDataSource,
                      valueExpr: "APPLY_ENTP_NAME",
                      displayExpr: "APPLY_ENTP_NAME",
                      showClearButton: true,
                      searchEnabled: true,
                      searchMode: "contains",
                      searchExpr: "APPLY_ENTP_NAME",
                      searchTimeout: 200,
                      minSearchLength: 0,
                      showDataBeforeSearch: false,
                      // disabled: true,
                      // acceptCustomValue: true,
                      // onCustomItemCreating: onCustomAPPLY_ENTP_NAMEItemCreating,
                    }}
                  >
                    <Label text={"회사명"} />
                    <RequiredRule message={"* 회사명을 입력해주세요."} />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"CLINIC_STEP_NAME"}
                    editorType="dxSelectBox"
                    editorOptions={{
                      dataSource: CLINIC_STEP_NAMEDataSource,
                      valueExpr: "CLINIC_STEP_NAME",
                      displayExpr: "CLINIC_STEP_NAME",
                      showClearButton: true,
                      searchEnabled: true,
                      searchMode: "contains",
                      searchExpr: "CLINIC_STEP_NAME",
                      searchTimeout: 200,
                      minSearchLength: 0,
                      showDataBeforeSearch: false,
                      // disabled: true,
                    }}
                  >
                    <Label text={"Phase"} />
                    <RequiredRule message={"* Phase를 입력해주세요."} />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"TRGT_DISS_NM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: TRGT_DISS_NMDataSource,
                      valueExpr: "lltCode",
                      // displayExpr: "lltNameKOR",
                      displayExpr: displayExpr,
                      showClearButton: true,
                      searchEnabled: true,
                      searchMode: "contains",
                      searchExpr: ["lltName", "lltNameKOR"],
                      searchTimeout: 200,
                      minSearchLength: 0,
                      showDataBeforeSearch: false,
                      multiline: false,
                      // showSelectionControls: true,
                      // applyValueMode: "useButtons",
                      // disabled: true,
                    }}
                  >
                    <Label text="적응증 (Indication)" />
                    <RequiredRule
                      message={"* 적응증 (Indication)을 입력해주세요."}
                    />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"CLINIC_EXAM_TITLE"}
                    editorType="dxTextBox"
                    editorOptions={{
                      showClearButton: true,
                    }}
                    colSpan={2}
                  >
                    <Label text={"프로젝트명"} />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"GOODS_NAME"}
                    editorType="dxTextBox"
                    editorOptions={{
                      showClearButton: true,
                    }}
                  >
                    <Label text={"제품명"} />
                  </SimpleItem>
                  <SimpleItem
                    dataField={"GNRL_CD_NM"}
                    editorType="dxTextBox"
                    editorOptions={{
                      showClearButton: true,
                    }}
                  >
                    <Label text={"성분명"} />
                  </SimpleItem>
                </Form>
              </Editing>

              <Column
                dataField={"PRJ_TP"}
                caption="프로젝트 구분"
                visible={false}
              />
              <Column
                dataField={"APPLY_ENTP_NAME"}
                caption="회사명"
                visible={false}
              />
              <Column
                dataField={"CLINIC_STEP_NAME"}
                caption="Phase"
                //   visible={false}
              />
              <Column
                dataField={"CLINIC_EXAM_TITLE"}
                caption="프로젝트명"
                width={400}
              />
              <Column dataField={"GOODS_NAME"} caption="제품명" width={200} />
              <Column dataField={"GNRL_CD_NM"} caption="성분명" width={200} />
              <Column
                dataField={"TRGT_DISS_NM"}
                caption="적응증 (Indication)"
                calculateDisplayValue={calculateDisplayValue}
              />
              <Column type={"buttons"}>
                <Button name="edit" disabled={editNDeleteDisabled} />
                <Button name="delete" disabled={editNDeleteDisabled} />
              </Column>
            </DataGrid>
          </SimpleItem>
          {/* <SimpleItem
                  dataField={"siteCt"}
                  editorType="dxNumberBox"
                  editorOptions={{
                    showClearButton: true,
                    format: "#,##0",
                  }}
                >
                  <Label text={"기관수 (Site)"} />
                </SimpleItem>
                <SimpleItem
                  dataField={"sCt"}
                  editorType="dxNumberBox"
                  editorOptions={{
                    showClearButton: true,
                    format: "#,##0",
                  }}
                >
                  <Label text={"조사대상자수 (Subject)"} />
                </SimpleItem> */}
          <SimpleItem dataField={"count"}>
            <Label text={"Count"} />
            <TwoNumberBoxComponent
              firstNumberBox={{
                placeholder: "기관수 (Site)",
                ref: siteCtRef,
                field: "siteCt",
              }}
              secondNumberBox={{
                placeholder: "조사대상자수 (Subject)",
                ref: sCtRef,
                field: "sCt",
              }}
              formDataSource={formDataSource}
            />
          </SimpleItem>
          <SimpleItem
            dataField={"role"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"수행업무"} />
          </SimpleItem>
          <SimpleItem
            dataField={"roleP"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"수행업무"} />
          </SimpleItem>
          <SimpleItem>
            <Label text={"수행기간"} />
            <TwoDateCheckBoxComponent
              firstDateBox={{
                placeholder: "수행시작일",
                field: "startDate",
                ref: startDateRef,
              }}
              secondDateBox={{
                placeholder: "수행종료일",
                field: "endDate",
                ref: endDateRef,
              }}
              checkBox={{
                field: "ps",
                text: "진행중",
                ref: psRef,
              }}
              formDataSource={formDataSource}
            />
          </SimpleItem>
          <SimpleItem
            dataField={"details"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
            colSpan={4}
          >
            <Label text={"상세내용"} />
          </SimpleItem>
        </Form>
      </Editing>

      <MasterDetail enabled={true} render={render} />

      <Column
        dataField={"PRJ_TP"}
        caption="프로젝트 구분"
        setCellValue={setPRJ_TPCellValue}
        calculateDisplayValue={calculateDisplayPRJ_TPValue}
      />
      <Column dataField={"id"} visible={false} />
      <Column
        dataField={"APPLY_ENTP_NAME"}
        caption="회사명"
        setCellValue={setAPPLY_ENTP_NAMECellValue}
      />
      <Column
        dataField={"CLINIC_EXAM_TITLE"}
        caption="프로젝트명"
        setCellValue={setCLINIC_EXAM_TITLECellValue}
        width={400}
      />
      <Column
        dataField={"GOODS_NAME"}
        caption="제품명"
        setCellValue={setGOODS_NAMECellValue}
      />
      <Column dataField={"GNRL_CD_NM"} caption="성분명" />
      <Column dataField={"TRGT_DISS_NM"} caption="적응증 (Indication)" />
      <Column
        dataField={"siteCt"}
        caption="기관수 (Site)"
        dataType={"number"}
        format={"#,##0"}
      />
      <Column
        dataField={"sCt"}
        caption="조사대상자수 (Subject)"
        dataType={"number"}
        format={"#,##0"}
      />
      <Column
        dataField={"CLINIC_STEP_NAME"}
        caption="Phase"
        setCellValue={setCLINIC_STEP_NAMECellValue}
      />
      {/* <Column
              dataField={"CLINIC_STEP_NAME_DETAILS"}
              caption="Phase 세부"
            /> */}
      <Column
        dataField={"OTR_CLINIC_STEP_NAME_DETAILS"}
        caption="기타 Phase 세부"
        visible={false}
      />
      <Column dataField={"role"} caption="수행업무" visible={false} />
      <Column dataField={"roleP"} caption="프로젝트 내 역할" visible={false} />
      <Column
        dataField={"startDate"}
        caption="수행시작일"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
        visible={false}
      />
      <Column
        dataField={"endDate"}
        caption="수행종료일"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
        visible={false}
      />
      <Column dataField={"ps"} caption="진행중" visible={false} />
      <Column dataField={"details"} caption="상세내용" visible={false} />
    </DataGrid>
  );
}
